import { makeStyles } from '@material-ui/styles';

const userStyles = makeStyles(theme => ({

}));

export default userStyles;